export const SEARCHLOCATION = "SEARCHLOCATION";

export const LOAD = "LOAD";

export const GETDAILY = "GETDAILY";

export const ERROR = 'ERROR';